import { Component, Inject, Injector, OnInit, Optional, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DsSideModalSide } from "../types/side-modal.types";

@Component({
  selector: "ds-side-modal",
  templateUrl: "./ds-side-modal.component.html",
  styleUrls: ["./ds-side-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DsSideModalComponent implements OnInit {
  childInjector!: Injector;
  modalData: {
    title?: string;
    description?: string;
    titleDsIcon?: string;
    innerComponent?: any;
    innerComponentData?: any;
    side: DsSideModalSide;
  } = { side: "right" };

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
    @Optional() private dialogRef: MatDialogRef<DsSideModalComponent>,
    private injector: Injector
  ) {}

  ngOnInit(): void {
    this.modalData = {
      title: this.dialogData?.title,
      description: this.dialogData?.description,
      titleDsIcon: this.dialogData?.titleDsIcon,
      innerComponent: this.dialogData?.innerComponent || null,
      innerComponentData: this.dialogData?.innerComponentData,
      side: this.dialogData?.side ?? "right",
    };

    this.childInjector = Injector.create({
      providers: [
        { provide: "dsSideModalData", useValue: this.modalData.innerComponentData },
        { provide: "dsSideModalConfig", useValue: this.modalData },
        ...(this.dialogRef ? [{ provide: MatDialogRef, useValue: this.dialogRef }] : []),
      ],
      parent: this.injector,
    });
  }

  close(): void {
    this.dialogRef?.close();
  }
}
